import AlertPaymentExisting9sContainer from './alert-payment-existing-9s-container';

export default AlertPaymentExisting9sContainer;
